export const heartPath = new Path2D(
  'M20 134a70 70 0 010-99c27-27 71-27 98 0l10 10 10-10c27-27 71-27 98 0 27 28 27 72 0 99L128 242 20 134z'
)
